import { render, staticRenderFns } from "./LegionellaStandards.vue?vue&type=template&id=60cffb0a"
import script from "./LegionellaStandards.vue?vue&type=script&lang=js"
export * from "./LegionellaStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSkeletonLoader,VToolbarTitle})
